import { render, staticRenderFns } from "./DashboardLayoutDataEdit.vue?vue&type=template&id=5e95572a&"
import script from "./DashboardLayoutDataEdit.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutDataEdit.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayoutDataEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports